'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/react.js
 ** module id = 357
 ** module chunks = 2 4 5 7 8 10 11
 **/